import Vue from 'vue';
import './plugins/vuetify.ts';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

/**
 * Plugins
 */
// i18n
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

import messages from './i18n/global/fr.json';

const i18n = new VueI18n({
	locale: 'fr',
	messages,
});

// vue-fragment
import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin);


/**
 * Composants
 */
import TimePickerInput from '@/components/_global/TimePickerInput.vue';
Vue.component('app-time-picker-input', TimePickerInput);

import DatePickerInput from '@/components/_global/DatePickerInput.vue';
Vue.component('app-date-picker-input', DatePickerInput);

import DynamicZoom from '@/components/_global/DynamicZoom.vue';
Vue.component('app-dynamic-zoom', DynamicZoom);

import CenteredMessage from '@/components/_global/CenteredMessage.vue';
Vue.component('app-centered-message', CenteredMessage);

import FilterControl from '@/components/_global/FilterControl.vue';
Vue.component('app-filter-control', FilterControl);

import DataTable from '@/components/_global/DataTable.vue';
Vue.component('data-table', DataTable);

import Dialog from '@/components/_global/Dialog.vue';
Vue.component('app-dialog', Dialog);

import Snackbar from '@/components/_global/snackbar/Snackbar.vue';
Vue.component('app-snackbar', Snackbar);

import Loading from '@/components/_global/Loading.vue';
Vue.component('app-loading', Loading);

/**
 * Transition
 */
Vue.component('app-transi', {
	template: '<transition mode="out-in" name="fade-transition"><router-view></router-view></transition>'
});

new Vue({
	router,
	i18n,
	store,
	render: (h) => h('app-transi'),
}).$mount('#app');
